// #region Imports
import React, { useState, useMemo } from 'react';
import NovaVendaSection from '../../components/Vendas/NovaVenda/NovaVendaSection';
import CheckoutModal from '../../components/Vendas/CheckoutModal/CheckoutModal';
import HistoricoVendasTable from '../../components/Vendas/Historico/HistoricoVendasTable';
import useVendas from '../../hooks/useVendas';
import useClientes from '../../hooks/useClientes';
import useFuncionarios from '../../hooks/useFuncionarios';
import { useProdutos } from '../../hooks/useProdutos';
import useServicos from '../../hooks/useServicos';
import { formatCurrency } from '../../../shared/helpers';
import cartIcon from '../../assets/vendasIcon.svg';
import './Vendas-Page.scss'; // garante aplicação dos estilos da página
// #endregion

// #region Componente
export default function VendasPage() {
  // #region Dados externos
  const { clientes } = useClientes();
  const { funcionarios } = useFuncionarios();
  const { items: produtos } = useProdutos();
  const { servicos } = useServicos();
  const vendasHook = useVendas({
    produtosProvider: produtos,
    servicosProvider: servicos,
    funcionariosProvider: funcionarios,
  });
  const {
    cart,
    addProduto,
    addServico,
    removeItem,
    updateQuantidade,
    clearCart,
    totalCarrinho,
    criarVenda,
    vendas,
    resumo,
  } = vendasHook;
  // #endregion

  // #region Estado UI
  const [mainTab, setMainTab] = useState('NOVA');
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [histFilters, setHistFilters] = useState({ q: '', status: 'TODOS' });
  // #endregion

  // #region Derivados
  const vendasFiltradas = useMemo(() => {
    let list = vendas;
    if (histFilters.status !== 'TODOS') {
      list = list.filter(v => v.status === histFilters.status);
    }
    if (histFilters.q) {
      const norm = histFilters.q.toLowerCase();
      list = list.filter(
        v =>
          String(v.id).includes(norm) ||
          String(v.cliente_id || '').includes(norm) ||
          String(v.funcionario_id || '').includes(norm),
      );
    }
    return list;
  }, [vendas, histFilters]);
  // #endregion

  // #region Handlers
  function confirmarVenda(form) {
    const payload = {
      cliente_id: Number(form.cliente_id),
      funcionario_id: Number(form.funcionario_id),
      itens: cart,
      valor_total: totalCarrinho,
      is_fiado: form.is_fiado,
      observacoes: form.observacoes,
    };
    criarVenda(payload);
    clearCart();
    setCheckoutOpen(false);
    setMainTab('NOVA');
  }
  // #endregion

  // #region Render
  return (
    <div className="vendas-page">
      <div className="vendas-header">
        <div className="vh-left">
          <h1>Vendas</h1>
          <p>Gerencie suas vendas e histórico</p>
        </div>
        <div className="vh-right">
          <button
            className="btn-finalizar-header"
            disabled={cart.length === 0}
            onClick={() => setCheckoutOpen(true)}
          >
            <img src={cartIcon} alt="Carrinho" className="icon" />
            <span>Finalizar Venda ({formatCurrency(totalCarrinho)})</span>
          </button>
        </div>
      </div>

      {/* Abas principais */}
      <div className="main-tabs refined">
        <button
          className={mainTab === 'NOVA' ? 'active' : ''}
          onClick={() => setMainTab('NOVA')}
        >
          Nova Venda
        </button>
        <button
          className={mainTab === 'HIST' ? 'active' : ''}
          onClick={() => setMainTab('HIST')}
        >
          Histórico
        </button>
        <span className="indicator" data-tab={mainTab} />
      </div>

      {mainTab === 'NOVA' && (
        <NovaVendaSection
          produtos={produtos}
          servicos={servicos}
          funcionarios={funcionarios}
          cart={cart}
          onAddProduto={addProduto}
          onAddServico={addServico}
          onRemoveItem={removeItem}
          onUpdateQtd={updateQuantidade}
          total={totalCarrinho}
        />
      )}
      {mainTab === 'HIST' && (
        <div className="historico-section">
          <div className="kpi-grid">
            <div className="kpi-card">
              <span className="kpi-label">Total em Vendas</span>
              <span className="kpi-value">{formatCurrency(resumo.totalValor)}</span>
            </div>
            <div className="kpi-card">
              <span className="kpi-label">Vendas Finalizadas</span>
              <span className="kpi-value">{resumo.finalizadas}</span>
            </div>
            <div className="kpi-card">
              <span className="kpi-label">Vendas Pendentes</span>
              <span className="kpi-value">{resumo.pendentes}</span>
            </div>
          </div>
          <HistoricoVendasTable
            vendas={vendasFiltradas}
            filters={histFilters}
            onFiltersChange={setHistFilters}
          />
        </div>
      )}
      <CheckoutModal
        open={checkoutOpen}
        cart={cart}
        total={totalCarrinho}
        clientes={clientes}
        funcionarios={funcionarios}
        onClose={() => setCheckoutOpen(false)}
        onConfirm={confirmarVenda}
      />
    </div>
  );
  // #endregion
}
